import html from "html-literal";

export default () => html`
  <footer>
    <p>&copy; RiskRadar</p>
  </footer>
`;
